import type { TenantImportAnswer } from '@einwert/valuation-api-client'

export function confirmedAnswers(previous: TenantImportAnswer[], answers: TenantImportAnswer[]): TenantImportAnswer[] {
    const confirmed = new Map(previous.map((answer) => [answer.question.id, answer]))
    for (const answer of answers) {
        if (answer.selected_option_ids.length || answer.text.trim()) {
            confirmed.set(answer.question.id, answer)
        }
    }
    return [...confirmed.values()]
}
